import * as UtilizationModels from '../../models/utilization/utilization';
import { UtilizationSearchModel } from '../../models/utilization/utilizationSearch';
import { SpecificationModel } from '../../models/specification/specification';


export class GetList {
  static readonly type = '[Utilization] List';
  constructor(public Search: UtilizationSearchModel) { }
}

export class SetSearch {
  static readonly type = '[Utilization] Set Search';
  constructor(public Search: UtilizationSearchModel) {}
}

export class ResetSearch {
  static readonly type = '[Utilization] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[Utilization] Set List Page';
  constructor(public Search: UtilizationSearchModel) { }
}

export class Insert {
  static readonly type = '[Utilization] Insert';
  constructor(public Invoice: UtilizationModels.UtilizationModel, public Version: number) { }
}

export class GetFilteredReport {
  static readonly type = '[Utilization] GetFilteredReport';
  constructor(public Search: UtilizationSearchModel) {}
}

export class DisposeSearch {
  static readonly type = '[Utilization] DisposeSearch';
  constructor() { }
}
